import cn from "classnames";
import styles from "./FieldBage.module.scss";
import { HashFactorName, UNIT_NAME } from "@utils/hash.utils";
import { memo, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { ALGOS_E } from "@constants/Algos";
import { Input } from "../Input/Input";
import { Select } from "antd";
import { DetailedHTMLProps, HTMLAttributes } from "react";

export interface FieldBagePropsI
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  name?: string;
  up?: boolean;
  bage?: string;
  selector?: string[];
  defaultSpeed?: number;
  defaultValue?: number | string;
  oldValue?: number;
  oldBage?: string;
  //for reset field
  reset?: number;
  disabled?: boolean;
  admin_setting?: number;
  hasPrevValue?: boolean;
  hasCleanUp?: boolean;
  min?: number;
  bageAlgo?: ALGOS_E;
  isError?: boolean;
  bageClassName?: string;
  outlined?: boolean;
  readonly?: boolean;
  regExp?: RegExp;

  getValue?(v: string, badge?: string): void;
  onChangedValue?(): void;
  onClearClick?(): void;
}

function FieldBage({
  name,
  bage,
  up,
  className,
  selector,
  defaultSpeed,
  defaultValue,
  oldValue,
  oldBage,
  reset,
  id,
  admin_setting,
  hasCleanUp,
  hasPrevValue = true,
  bageAlgo = ALGOS_E.SHA256,
  isError,
  bageClassName,

  getValue,
  onChangedValue: onChangeValue,
  ...props
}: FieldBagePropsI) {
  const UNIT = UNIT_NAME[bageAlgo];
  const { formatMessage } = useIntl();
  const [lastValue] = useState(oldValue);
  const [inputValue, setInputValue] = useState<string>(
    defaultValue?.toString() || oldValue?.toString() || ""
  );
  const [value, setValue_] = useState<string>(
    oldValue?.toString() || defaultValue?.toString() || ""
  );
  const [openSelector, setOpenSelector] = useState<boolean>(false);
  const [badgeValue, setBadgeValue] = useState<HashFactorName | string>(
    bage || (selector && selector[4]) || ""
  );

  const setValue = (v: string) => {
    setValue_((was) => {
      was !== v && onChangeValue && onChangeValue();
      return v;
    });
  };

  const onSelect = (s: string) => {
    setBadgeValue(s);
    setOpenSelector(false);
    !(value === "" || isNaN(value as any)) && onChangeValue && onChangeValue();
  };

  useEffect(() => {
    if (!!bage) setBadgeValue(bage);
  }, [bage]);

  useEffect(() => {
    setValue(inputValue);
  }, [inputValue]);

  useEffect(() => {
    if (inputValue.length === 0) {
      setValue("");
      return;
    }
  }, [inputValue]);

  //for reset
  useEffect(() => {
    if (!reset) return;
    setInputValue(lastValue?.toString() || "");
    setValue(lastValue?.toString() || "");
  }, [reset]);

  useEffect(() => {
    if (!getValue) return;

    if (inputValue.length === 0) getValue("0", badgeValue);
    getValue(inputValue, badgeValue);
  }, [inputValue, badgeValue]);

  const onClear = () => {
    if (props.onClearClick) props.onClearClick();
    setInputValue("");
  };

  useEffect(() => {
    console.log("inputValue", inputValue);
  }, [inputValue]);

  const showPrevBlock =
    hasPrevValue && !!lastValue && lastValue !== +inputValue;

  return (
    <Input
      size="small"
      id={id}
      label={<span className={styles.label}>{name}</span>}
      value={inputValue?.toString()}
      regExp={props.regExp}
      onChange={(e) => {
        setInputValue(e.target.value);
      }}
      wrapClassName={cn(styles.input, className, {
        [styles.disabled]: props.disabled,
        [styles.error]: isError,
      })}
      data-bage={badgeValue}
      {...props}
      disabled={props.disabled}
      outlined={props.outlined}
      readOnly={props.readonly}
      addonAfter={
        <label>
          {selector ? (
            <Select
              size="small"
              className={cn(styles.select)}
              //dropdownStyle={{ width: "initial" }}
              styles={{
                popup: {
                  root: {
                    width: "initial"
                  }
                }
              }}
              value={badgeValue}
              onChange={(value) => onSelect(`${value}${UNIT}`)}
              disabled={props.disabled || props.readonly}
              options={selector.map((s, i) => ({
                label: (
                  <span>
                    {s}
                    {UNIT}
                  </span>
                ),
                value: s,
              }))}
            />
          ) : (
            <span className={styles.addon}>{badgeValue}</span>
          )}
        </label>
      }
    />
  );
}
export default memo(FieldBage);
